export default __webpack_public_path__ + "static/media/respondent_background.8367c7c6.jpg";